/**
 * Only the store home and register-card routes may omit crawl blocking when the account allows indexing.
 * @param {string|undefined|null} routeName Nuxt route name
 * @param {boolean} blockSearchEngineIndexing from account (true = block)
 * @returns {boolean} true when indexing signals should allow indexing for this route
 */
export function shouldAllowSearchIndexing (routeName, blockSearchEngineIndexing) {
  if (blockSearchEngineIndexing) {
    return false
  }
  return routeName === 'home' || routeName === 'index' || routeName === 'register'
}
